<template>
  <div id="content-lesson" onCopy="return false" onCut="return false">
    <div v-if="aula.type === 'LV'" class="videoWrapper">
      <nt-video :type="aula.video.type"
        :path="aula.video.id"
        :endVideo="videoEnded"
        :progress="aula.progress"
        :updateProgress="updateLessonProgress"
        ref="video"
        autoplay/>
    </div>

    <div v-if="aula.title" class="pa-3">
      <div class="subheading bold text-center">{{ aula.title }}</div>
      <v-runtime-template v-if="aula.description" :template="aula.description" class="text-body-1 lesson-content"/>
    </div>

    <div class="pa-3" v-if="aula.content">
      <v-runtime-template :template="aula.content" class="lesson-content"/>
    </div>
    <v-row dense class="mb-5" v-if="aula.type === 'LC'">
      <v-col cols="12" class="text-center" v-if="aula.progress === 1">
        <v-btn large depressed color="primary" disabled>Aula Finalizada!</v-btn>
      </v-col>
      <v-col cols="12" class="text-center" v-else>
        <v-btn text block color="primary" @click="finalizeLesson">
          <v-icon left>mdi-check</v-icon> Finalizar Aula
        </v-btn>
        <div>
          <small>Clique em <b>finalizar aula</b> para marcar a aula como finalizada.</small>
        </div>
      </v-col>
    </v-row>

    <div class="pa-2" v-if="aula.type === 'LL'">
      <nt-exercise-list-info v-if="this.exerciseListInfo.show"
        :value="exerciseListInfo"
        :previousLesson="previousLesson"
        :nextLesson="nextLesson"
        @load="loadExerciseList()"
        @nextLesson="toNextLesson()"
        @previousLesson="toPreviousLesson()"/>
      <nt-exercise-list v-else
        :exerciseList="aula.exerciseList"
        :previousLesson="previousLesson"
        :nextLesson="nextLesson"
        :progress="aula.progress"
        :matriculaId="parseInt(matriculaId)"
        :aulaId="parseInt(aulaId)"
        @nextLesson="toNextLesson()"
        @previousLesson="toPreviousLesson()"/>
    </div>

    <v-row dense justify="space-between" v-if="showNavigationButtons" class="mt-2">
      <v-col class="shrink">
        <v-tooltip top v-if="isPreviousLesson">
          <template v-slot:activator="{ on, attrs }">
            <v-btn depressed v-on="on" v-bind="attrs" large color="info" @click="toPreviousLesson()">
              <v-icon dark>mdi-skip-previous</v-icon>
            </v-btn>
          </template>
          <span>Aula anterior: {{ previousLesson.title }}</span>
        </v-tooltip>
      </v-col>
      <v-col class="shrink">
        <v-tooltip top v-if="isNextLesson">
          <template v-slot:activator="{ on, attrs }">
            <v-btn depressed v-on="on" v-bind="attrs" large color="info" @click="toNextLesson()">
              <v-icon dark>mdi-skip-next</v-icon>
            </v-btn>
          </template>
          <span>Próxima aula: {{ nextLesson.title }}</span>
        </v-tooltip>
      </v-col>
    </v-row>

    <v-row v-if="aula.files.length">
      <v-col cols="12" class="title d-flex align-center">
        <v-icon color="secondary" left>mdi-file-multiple</v-icon> Materiais de Apoio
      </v-col>
      <v-col cols="12" v-for="(file, index) in aula.files" :key="index" class="wrapword">
        <v-card outlined flat @click="showLessonMaterial(file)" class="clickable">
          <v-card-subtitle>
            <v-icon left>{{ fileIcon(file.name) }}</v-icon> {{ file.title }}
          </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="modalNextLesson.active" max-width="900px" persistent>
      <v-card>
        <v-card-title class="d-block text-center">
          <span class="text-h6">
            <v-icon>mdi-thumb-up</v-icon>
          </span>
        </v-card-title>
        <v-card-text class="d-block text-center">
          <div>Você finalizou mais uma aula.</div>
          <div>A próxima aula começará em <b>{{ modalNextLesson.timer }}</b>.</div>
        </v-card-text>
        <v-card-actions class="d-block text-center">
          <v-btn depressed color="error" @click.stop="modalNextLesson.cancel=true; modalNextLesson.active=false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <router-view/>

    <nt-lesson-file v-if="showFileComputed"
      :dialog.sync="showFileComputed"
      :file-id="aula.file.fileId"
      :file-name="aula.file.fileName"
      :display-name="aula.file.displayName"
      :type="aula.file.type"/>
  </div>
</template>

<script>
import { SalaDeAula } from '@/services/resources'
import Video from '@/components/Utils/Video/Index'
import ExerciseList from '@/components/SalaDeAula/ExerciseList/Index'
import ExerciseListInfo from '@/components/SalaDeAula/ExerciseList/Info'
import VueRuntimeTemplate from '@/components/Utils/VueRuntimeTemplate'
import LessonFile from '@/components/SalaDeAula/LessonFile'

const getDefaultModalNextLesson = () => {
  return {
    active: false,
    timer: 5,
    cancel: false
  }
}

const defaultData = () => {
  return {
    aula: {
      type: '',
      title: '',
      description: '',
      progress: 0,
      video: {
        type: '',
        id: ''
      },
      content: '',
      files: [],
      exerciseList: {
        show: false,
        instances: {},
        nextExercise: 0,
        deadlineCountDownEnd: null,
        status: 'NI',
        created_at: ''
      },
      file: {
        fileId: '0',
        fileName: '',
        displayName: '',
        type: ''
      }
    },
    turmaId: null,
    previousLesson: null,
    exerciseListInfo: {
      show: true,
      deadline: null,
      response_interval_init: null,
      response_interval_end: null
    },
    nextLesson: null,
    timeoutReduceTime: null,
    timeoutVideoEnded: null,
    modalNextLesson: getDefaultModalNextLesson(),
    destroyVideo: true,
    showFile: false
  }
}

export default {
  components: {
    ntVideo: Video,
    ntExerciseList: ExerciseList,
    ntExerciseListInfo: ExerciseListInfo,
    'v-runtime-template': VueRuntimeTemplate,
    ntLessonFile: LessonFile
  },
  beforeRouteUpdate (to, from, next) {
    if (this.$refs.video && this.destroyVideo) {
      this.$refs.video.$destroy()
    }
    this.clearTimeout()
    if (to.params.aulaId !== from.params.aulaId) {
      this.getLessonData(to.params.aulaId)
        .then(() => {
          const wrapperLessonContent = document.querySelector('.wrapper-lesson-content')
          window.scrollTo(0, wrapperLessonContent.offsetTop - 56)
        })
    }
    next()
  },
  beforeRouteLeave (to, from, next) {
    if (to.name.indexOf(from.name) !== -1) { this.$destroy() }
    next()
  },
  data () {
    return defaultData()
  },
  mounted () {
    this.getLessonData(this.aulaId)
    window.addEventListener('resize', this.calcVideosSize)
  },
  beforeDestroy () {
    this.clearTimeout()
  },
  props: ['matriculaId', 'aulaId'],
  methods: {
    getLessonData (aulaId) {
      this.resetData()
      return SalaDeAula.getLesson(this.matriculaId, aulaId)
        .then((response) => {
          const lesson = response.data.lesson
          this.previousLesson = response.data.previousLesson
          this.nextLesson = response.data.nextLesson
          this.aula.title = lesson.title
          this.aula.description = lesson.description
          this.aula.progress = lesson.progresso
          this.turmaId = response.data.groupId
          switch (lesson.type_lesson) {
            case 'LV':
              if (lesson.video !== null) {
                this.aula.type = 'LV'
                this.aula.video.type = lesson.video.file.type
                this.aula.video.id = lesson.video.file.path
              } else {
                this.$toasted.global.error({ message: 'Vídeo aula não encontrada.' })
              }
              break
            case 'LC':
              this.aula.type = 'LC'
              this.aula.content = lesson.content_text || ''
              setTimeout(() => {
                document.querySelectorAll('audio.nodownload').forEach((item) => {
                  item.setAttribute('controlsList', 'nodownload')
                })
              }, 500)
              break
            case 'LL':
              if ((lesson.lesson_exercise_list.exercise_list.deadline !== null ||
                lesson.lesson_exercise_list.response_interval_init !== null) &&
                lesson.lesson_exercise_list.exercise_list_instances.length === 0) {
                this.exerciseListInfo = {
                  deadline: lesson.lesson_exercise_list.exercise_list.deadline,
                  response_interval_init: lesson.lesson_exercise_list.response_interval_init,
                  response_interval_end: lesson.lesson_exercise_list.response_interval_end,
                  show: true
                }
              } else {
                this.loadExerciseList()
              }

              this.aula.type = 'LL'
              break
          }
          if (lesson.contents) {
            const contents = []
            Object.values(lesson.contents).forEach(item => {
              // Verifica se o conteúdo é vinculado a alguma turma,
              // e caso seja verifica se a matrícula do aluno está
              // vinculada a esta turma
              const show = item.group_id ? item.group_id === this.turmaId : true

              // Verfica se o conteúdo é um arquivo ou texto
              if (item.file_id && show) {
                const aux = item.file.path.split('/')
                contents.push({
                  id: item.file_id,
                  name: aux[aux.length - 1],
                  type: item.file.type,
                  title: item.title
                })
              } else if (show) {
                this.aula.content += item.text
              }
            })

            this.aula.files = this.aula.files.concat(contents)
          }

          setTimeout(() => {
            this.calcVideosSize()
            this.setAudiosNoDownload()
          }, 500)

          // document.getElementById('content-lesson').scrollIntoView()
          // let wrapperLessonContent = this.$el.querySelector('.wrapper-lesson-content')
          // wrapperLessonContent.scrollTop = wrapperLessonContent.scrollHeight
          return response
        })
        .catch((responseError) => {
          if (responseError.status === 412) {
            this.$toasted.global.error({ message: responseError.body.mensagem })
            this.$router.replace({
              name: 'salaDeAula.aula',
              params: {
                matriculaId: this.matriculaId,
                aulaId: responseError.body.lesson_id
              }
            })
          } else {
            console.log(responseError)
            this.$toasted.global.error({ message: 'Erro ao carregar os dados da aula.' })
          }
        })
    },
    loadExerciseList () {
      SalaDeAula.getExerciseList(this.matriculaId, this.aulaId)
        .then((response) => {
          this.aula.exerciseList.instances = { ...response.body.return.exercise_list_instance.instances }
          this.aula.exerciseList.nextExercise = response.body.return.next_exercise
          this.aula.exerciseList.status = response.body.return.exercise_list_instance.status
          this.aula.exerciseList.created_at = response.body.return.exercise_list_instance.created_at
          // Verifica se a lista de exercícios possui um deadline definido
          if (response.body.return.exercise_list_instance.deadline) {
            this.aula.exerciseList.deadlineCountDownEnd = response.body.return.exercise_list_instance.deadlineCountDownEnd
          }

          // Garante que as informações iniciais da lista de exercícios
          // estejam escondidas e mostra a lista de exercícios em questão
          this.exerciseListInfo.show = false
        })
        .catch((responseError) => {
          if (responseError.status === 428 || responseError.status === 422) {
            this.$toasted.global.error({ message: responseError.body.return.message })
          } else {
            console.log(responseError)
            this.$toasted.global.error({ message: responseError.statusText })
          }
        })
    },
    resetData () {
      Object.assign(this.$data, defaultData())
    },
    videoEnded () {
      if (this.nextLesson !== null) {
        this.modalNextLesson.active = true
        const timerNextlesson = this.modalNextLesson.timer * 1000
        this.reduceTime()
        setTimeout(() => {
          if (!this.modalNextLesson.cancel) {
            this.$router.push({
              name: 'salaDeAula.aula',
              params: {
                matriculaId: this.matriculaId,
                aulaId: this.nextLesson.id
              }
            })
          } else {
            this.modalNextLesson = this.getDefaultModalNextLesson()
          }
        }, timerNextlesson)
      }
      this.updateLessonProgress(1)
    },
    finalizeLesson () {
      if (this.aula.type === 'LC') {
        this.updateLessonProgress(1)
        this.$router.push({
          name: 'salaDeAula.aula',
          params: {
            matriculaId: this.matriculaId,
            aulaId: this.nextLesson.id
          }
        })
      }
    },
    toNextLesson () {
      this.destroyVideo = true
      if (this.isNextLesson) {
        this.$router.push({
          name: 'salaDeAula.aula',
          params: {
            matriculaId: this.matriculaId,
            aulaId: this.nextLesson.id
          }
        })
      }
    },
    toPreviousLesson () {
      this.destroyVideo = true
      if (this.isPreviousLesson) {
        this.$router.push({
          name: 'salaDeAula.aula',
          params: {
            matriculaId: this.matriculaId,
            aulaId: this.previousLesson.id
          }
        })
      }
    },
    updateLessonProgress (progress) { /* Proporção da aula já vista - de 0 a 1 */
      this.$store.dispatch('SalaDeAula/updateLessonProgress', {
        enrollmentId: this.matriculaId,
        lessonId: this.aulaId,
        progress: progress
      })
    },
    reduceTime () {
      setTimeout(() => {
        if (this.modalNextLesson.timer > 0 && this.modalNextLesson.active) {
          this.modalNextLesson.timer--
          this.reduceTime()
        }
      }, 1000)
    },
    clearTimeout () {
      if (this.timeoutReduceTime) {
        clearTimeout(this.timeoutReduceTime)
      }

      if (this.timeoutVideoEnded) {
        clearTimeout(this.timeoutVideoEnded)
      }
    },
    fileIcon (fileName) {
      const aux = fileName.split('.')
      const fileType = aux[aux.length - 1]
      switch (fileType) {
        case 'mp3':
          return 'mdi-play-circle-outline'
        default:
          return 'mdi-file-multiple'
      }
    },
    showLessonMaterial (file) {
      this.destroyVideo = false
      this.aula.file = {
        fileId: file.id.toString(),
        fileName: file.name,
        displayName: file.title,
        type: file.type
      }
      this.showFileComputed = true
    },
    calcVideosSize () {
      // When the window is resized
      const allVideos = document.querySelectorAll('.lesson-content iframe')

      // The element that is fluid width
      const fluidEl = document.querySelector('.lesson-content')

      let newWidth = fluidEl ? fluidEl.clientWidth : 0
      newWidth = newWidth > 800 ? 800 : newWidth

      // Resize all videos according to their own aspect ratio
      allVideos.forEach(function (item) {
        item.removeAttribute('height')
        item.removeAttribute('width')
        item.style.width = newWidth + 'px'
        item.style.height = (newWidth * (9 / 16)) + 'px'
        item.style.margin = 'auto'
        item.style.border = 'none'
      })
    },
    setAudiosNoDownload () {
      document.querySelectorAll('audio.nodownload').forEach((item) => {
        item.setAttribute('controlsList', 'nodownload')
      })
    }
  },
  computed: {
    getVideo () {
      return ''
    },
    showNavigationButtons () {
      return (this.isPreviousLesson || this.isNextLesson) && this.aula.type !== 'LL'
    },
    isPreviousLesson () {
      return this.previousLesson !== null
    },
    isNextLesson () {
      return this.nextLesson !== null
    },
    showFileComputed: {
      get () {
        return this.showFile
      },
      set (value) {
        if (!value) {
          this.aula.file = {
            fileId: '0',
            fileName: '',
            displayName: '',
            type: ''
          }

          this.showFile = false
        } else {
          this.showFile = true
        }
      }
    }
  }
}
</script>

<style lang="scss">
#content-lesson .lesson-content {
  max-width: 650px;
  margin: auto;
  word-break: break-word;

  ul, ol {
    margin-left: 10px !important;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  li {
    list-style-position: inside;
  }

  audio {
    outline: none;
  }
}

.clickable {
  cursor: pointer;
}

.lesson-materials {
  .layout {
    justify-content: space-around;

    .flex {
      flex-grow: 0;
    }
  }
}

.wrapword {
  white-space: -moz-pre-wrap !important;  /* Mozilla, since 1999 */
  white-space: -webkit-pre-wrap;          /* Chrome & Safari */
  white-space: -pre-wrap;                 /* Opera 4-6 */
  white-space: -o-pre-wrap;               /* Opera 7 */
  white-space: pre-wrap;                  /* CSS3 */
  word-wrap: break-word;                  /* Internet Explorer 5.5+ */
  word-break: break-all;
  white-space: normal;
}
</style>
